import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { CREATE_WATCHLIST_IGNORING_PROPERTY } from '../types';
import {
  createWatchListIgnoringPropertyPending,
  createWatchListIgnoringPropertyFulfilled,
  createWatchListIgnoringPropertyRejected,
} from '../actions';
import {
  sendApiRequest,
  notifyError,
} from '../../../actions';

import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'post',
  url: 'watchlist/createWatchListIgnoringProperty',
  onSuccess: [
    createWatchListIgnoringPropertyFulfilled,
    //   () => notifySuccess(WATCHLIST_IGNORING_PROPERTY_MESSAGES.SUCCESS),
  //  () => windowReload()
  ],
  onError: [
    createWatchListIgnoringPropertyRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const createWatchListIgnoringPropertyEpic$ = action$ => action$.pipe(
  ofType(CREATE_WATCHLIST_IGNORING_PROPERTY.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(createWatchListIgnoringPropertyPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default createWatchListIgnoringPropertyEpic$;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/createWatchListIgnoringPropertyEpic.js